export const PROJECT_SPEC = 'project.spec'
export const ADD_BUTTON = 'misc.add'
export const REMOVE = 'misc.remove'

export const SPEC_ORDER = {
    peripheral_interfaces_i_2_c: [
        'portNumber',
        'initiator',
        'interfaceFrequency',
        'device',
        'deviation'
    ],
    peripheral_interface_spi: [
        'portNumber',
        'initiator',
        'spiMode',
        'interfaceFrequency',
        'vendorOne',
        'partNumberOne',
        'vendorTwo',
        'partNumberTwo'
    ],
    memory_storage_device: [
        'device',
        'memoryType',
        'memorySize',
        'busWidth',
        'maxFrequency',
        'runningFrequency',
        'vendor',
        'partNumber',
        'maxTemperature',
        'refreshRate'
      ],
      fsi_interface: [
        'device',
        'initiator',
        'interfaceFrequency',
        'mode',
        'vendor',
        'partNumber'
      ],
      peripheral_interfaces_dap: [
        'portNumber',
        'initiator',
        'dapMode',
        'dapIo',
        'interfaceFrequency',
        'vendor',
        'partNumber'
      ],
      peripheral_interfaces_eth: [
        'item',
        'portNumber',
        'speed',
        'vendor',
        'partNumber'
      ],
      peripheral_interfaces_usb_2: [
        'portNumber',
        'hostDevice',
        'interfaceFrequency',
        'connector',
        'vendor',
        'partNumber'
      ],
      peripheral_interfaces_usb_3: [
        'controllerNumber',
        'hostDevice',
        'interfaceFrequency',
        'connector',
        'vendor',
        'partNumber'
      ],
      peripheral_interfaces_pcie: [
        'controllerNumber',
        'pcieMode',
        'numberLanes',
        'interfaceFrequency',
        'connector',
        'vendor',
        'partNumber'
    ],
    display_hdmi: [
        'mstSupport',
        'displayMode',
        'serializerVendor',
        'serializerPartNumber',
        'serializerBandwidth',
        'header',
        'dpAux',
        'initiator',
        'inferfaceFrequency',
        'deviceVendor',
        'partNumber'
    ],
    camera_video_input: [
      'portNumber',
      'csiGroup',
      'csiMode',
      'numberOfLanes',
      'deserializerVendor',
      'deserializerPartNumber',
      'deserializerInstanceNumber',
      'estimatedTotalBandwidth'
    ],
    system_ethernet_switch: [
      'vendor',
      'partNumber',
      'port'
    ],
    system_saftey_mcu: [
      'deviceVendor',
      'devicePartNumber',
      'interface'
    ]
}

export const NESTED_SPEC_ORDER = {
  peripheral_interfaces_i_2_c: {
    device: [
      'vendor',
      'partNumber',
      'address',
      'voltageLevel'
    ]
  },
  display_hdmi: {
    header: [
      'headerNumber',
      'horizontalResolution',
      'verticalResolution',
      'pixelFormat',
      'frameRate',
    ]
  },
  system_ethernet_switch: {
    port: [
      'portNumber',
      'configuration',
      'speed',
      'phy',
      'connection',
    ]
  },
  system_saftey_mcu: {
    interface: [
      'interfaceName',
      'comments'
    ]
  }
}